import { useMemo } from 'react';

import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { GridColDef } from '@mui/x-data-grid-pro';
import { fullDateFormatter } from 'utils/grid';

const useColumnDefinitions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    return generateColumns(t);
  }, [t]);
};

const generateColumns = (t: TFunction): GridColDef[] => [
  {
    field: 'date',
    headerName: t('date'),
    type: 'date',
    minWidth: 150,
    valueFormatter: fullDateFormatter
  },
  {
    field: 'description',
    headerName: t('holidays.grid.description'),
    type: 'string',
    hideable: false,
    flex: 1,
    minWidth: 150
  },
  {
    field: 'holidayCompLeaveHours',
    headerName: t('holidays.grid.holidayCompLeaveHours'),
    type: 'number',
    minWidth: 95,
    align: 'left',
    headerAlign: 'left'
  }
];

export default useColumnDefinitions;
